const { isUrl, checkAdType, verifyCtid } = require("./vpadn-sdk-check.partial");
const { websdkParams } = require("./vpadn-sdk-parameters.partial");
const { cookieParamsValidator } = require("./vpadn-sdk-check.partial");
const { getTopReachableDomain } = require("./vpadn-sdk-cookie.partial");

const checkCookieNameIsExist = (name) => {
  return document.cookie
    .split(";")
    .some((item) => item.trim().startsWith(`${name}=`));
};

const getCookieOfObject = () => {
  return document.cookie
    .split(";")
    .map((item) => item.trim().split("="))
    .reduce((prev, curr) => {
      const [key, value] = curr;
      return {
        ...prev,
        [key]: value,
      };
    }, {});
};

/**
 * 211027>
 * Add Hinet third party tracking one in ten. The one is determined by ctid.
 */
//const initialHinet = () => {
//  try {
//    const CTID_NAME = "vpadn-ctid";
//    if (
//      checkCookieNameIsExist(CTID_NAME) ||
//      (window.localStorage && window.localStorage.getItem(CTID_NAME))
//    ) {
//      const getCookie = getCookieOfObject();
//      const ctidCookie = getCookie[CTID_NAME].split("_")[1].split(".")[0];
//      const CTID =
//        ctidCookie ||
//        (window.localStorage && window.localStorage.getItem(CTID_NAME));
//      if (Math.random() <= 0.3) {
//        const script = document.createElement("script");
//        script.async = true;
//        script.src = "https://t.ssp.hinet.net/utag.js";
//        document.getElementsByTagName("head")[0].appendChild(script);
//
//        script.onload = () => {
//          var partnerId = "7f1e29";
//          window.__hitagCmdQueue = window.__hitagCmdQueue || [];
//          function hiball() {
//            __hitagCmdQueue.push(arguments);
//          }
//          hiball("fire", partnerId);
//          hiball("cm", partnerId, `${CTID}`);
//        };
//      }
//    } else {
//      console.warn(
//        "[web-sdk] initialHinet: There is not vpadn-ctid in cookie or local storage."
//      );
//    }
//  } catch (error) {
//    console.error(`[web-sdk] initialHinet something wrong: ${error}`);
//  }
//};

//const initialEland = () => {
//  const script = document.createElement("script");
//  script.async = true;
//  script.src = "https://dmp.eland-tech.com/dmpreceiver/eland_tracker.js";
//  document.getElementsByTagName("head")[0].appendChild(script);
//  script.onload = () => {
//    if (checkCookieNameIsExist("vpadn-ctid")) {
//      const getCookie = getCookieOfObject();
//      const ctid = getCookie["vpadn-ctid"].split("_")[1].split(".")[0];
//      const dataJson = {
//        source: "VPON",
//        trackType: "view",
//        targetType: "usual",
//        trackSubfolderDepth: 1,
//        ecInfo: {
//          memberID: ctid,
//        },
//      };
//      ElandTracker.Track(dataJson);
//    }
//  };
//};

const endsWith = (str, suffix) => {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
};

const s4 = () => {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};

const genGuid = () => {
  return (
    s4() +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    s4() +
    s4()
  );
};

const getCookie = (c_name) => {
  var c_value = document.cookie;
  var c_start = c_value.indexOf(" " + c_name + "=");
  if (c_start == -1) {
    c_start = c_value.indexOf(c_name + "=");
  }
  if (c_start == -1) {
    c_value = null;
  } else {
    c_start = c_value.indexOf("=", c_start) + 1;
    var c_end = c_value.indexOf(";", c_start);
    if (c_end == -1) {
      c_end = c_value.length;
    }
    c_value = unescape(c_value.substring(c_start, c_end));
  }
  return c_value;
};

/* remove for CNA publisher, possibly cause is function name conflict
function setCookie(c_name,value,exdays){
  var exdate=new Date();
  exdate.setDate(exdate.getDate() + exdays);
  var c_value=escape(value) + ((exdays==null) ? "" : "; expires="+exdate.toUTCString());
  document.cookie=c_name + "=" + c_value;
}
*/

const uaMatch = (substr) => {
  return (
    (window.navigator ? window.navigator.userAgent : "").indexOf(substr) != -1
  );
};

const isSDKiOS = () => {
  return uaMatch("(iPad") || uaMatch("(iPod") || uaMatch("(iPhone");
};

const isIPhone = () => {
  return uaMatch("(iPhone");
};

const isSDKiOSNotIPhone = () => {
  return uaMatch("(iPad") || uaMatch("(iPod");
};

const parseParamsFromUrl = (url) => {
  var params = {};
  var key = "";
  var value = "";

  if (url.indexOf("?") != -1) {
    var ary = url.split("?")[1].split("&");
    for (var i in ary) {
      key = ary[i].split("=")[0];
      value = ary[i].split("=")[1];
      // replace sms body content
      if (value.indexOf("sms%3A") > -1 && value.indexOf("%3Fbody%3D") > -1) {
        value = replaceSMSContent(value);
      }
      // use %20 for encoded character of white space instead of ‘+’
      // replace '+' with '%20' form any content include '+'
      else if (value.indexOf("+") > -1) {
        value = value.replace(/\+/g, "%20");
      }
      value = decodeURIComponent(value);
      // replace '\r\n' for sms
      if (value.indexOf("\r\n") > -1 && value.indexOf("sms:") > -1) {
        value = value.replace(/\r\n/g, "\\n");
      }

      params[key] = value;
    }
  }
  return params;
};

const regexp_replace = (input, tagBeingReplaced, replaceWith) => {
  var regex = new RegExp("\\$\\{" + tagBeingReplaced + "\\}", "g");
  return input.replace(regex, replaceWith);
};

const parseCtidToObj = (ctid_dob) => {
  try {
    if (ctid_dob === null || ctid_dob === undefined) {
      return {
        ctid: null,
        timestamp: null,
      };
    }
    if (ctid_dob.split(".").length === 2) {
      const version = ctid_dob.split("_")[0];
      const ctid = ctid_dob.split("_")[1].split(".")[0];
      const timestamp = ctid_dob.split(".")[1];
      // 防止 cookie 還存在，但 localStorage 被清掉的情況，故再做一次儲存
      window.localStorage &&
        window.localStorage.setItem(
          "vpadn-ctid",
          `${version}_${ctid}.${timestamp}`
        );
      return {
        version,
        ctid,
        timestamp,
      };
    } else {
      return {
        ctid: ctid_dob,
        timestamp: null,
      };
    }
  } catch (error) {
    console.log(error);
  }
};

/**
 * fadeIn effect
 * @param {Object} el target element
 * @param {Number} ms transition duration
 * @param {Function} callback when transitionend event triggerd, execute callback function
 */
let fadeLock = null;

const fadeForFlrec = (el, action = "in", ms = 3, callback) => {
  try {
    console.log("action:" + action);
    if (action === "out") {
      clearTimeout(fadeLock);
      el.removeEventListener("transitionend", transitionendCallback);
      return;
    }

    if (action === "in") {
      ms = !isNaN(parseFloat(ms)) ? parseFloat(ms) : 3;
      el.style.opacity = 0;
      setTimeout(() => {
        el.style.transition = `opacity ${ms}s`;
        el.style.opacity = 1;
      }, 1);
      if (typeof callback === "function") {
        fadeLock = setTimeout(() => {
          console.log("fadeLock");
          clearTimeout(fadeLock);
          el.removeEventListener("transitionend", transitionendCallback);
          callback();
        }, ms * 1000 + 500);
        el.addEventListener("transitionend", transitionendCallback);
      }
    }

    function transitionendCallback() {
      console.log("transitionendCallback");
      clearTimeout(fadeLock);
      el.removeEventListener("transitionend", transitionendCallback);
      callback();
    }
  } catch (err) {
    console.warn(err);
  }
};

let fading = null;

const fade = (el, ms = 3, type = "in") => {
  if (fading) {
    clearInterval(fading);
  }
  /**
   * return if close button was defined as display == none
   */
  if (el.style.display === "none") {
    return;
  }
  if (ms === 0) {
    el.style.display = "block";
    el.style.opacity = 1;
    return;
  }
  const isIn = type === "in";
  let opacity = isIn ? 0 : 1;
  let interval = 50;
  let duration = ms * 1000;
  if (duration === 0) duration = 0.1;
  let gap = interval / duration;
  if (isIn) {
    el.style.display = "block";
    el.style.opacity = opacity;
  }

  const func = () => {
    opacity = isIn ? opacity + gap : opacity - gap;

    if (opacity <= 0) {
      clearInterval(fading);
      opacity = 0;
      el.style.display = "none";
    }

    if (opacity >= 1) {
      clearInterval(fading);
      opacity = 1;
    }
    el.style.opacity = opacity;
  };
  fading = setInterval(func, interval);
};

const getParams = (setLocation = location.href) => {
  const url = new URL(setLocation);
  const params = {};
  const paramsArr = url.search ? url.search.replace(/^\?/, "").split("&") : [];
  let value = "";
  for (let key of paramsArr) {
    if (key) {
      value = key.split("=");
      params[value[0]] = value[1];
    }
  }
  return params;
};

const calculateViewRate = (target) => {
  if (!target || !("getBoundingClientRect" in target)) {
    return;
  }

  const boundingRect = findFrameAbsoluteRect(target);
  let counter = 0;

  for (let i = 0; i <= 10; i++) {
    const position = {
      x: boundingRect.x + boundingRect.width / 2,
      y: boundingRect.y + (boundingRect.height * i) / 10,
    };

    if (
      window.top.document.elementFromPoint(position.x, position.y) === target
    ) {
      counter++;
    }
  }

  return {
    viewPercent: (counter - 1) / 10,
  };
};

function isElementInsideContainer(container, target) {
  if (!container || !target) {
    return false;
  }

  if (container === target) {
    return true;
  }

  let iframes = [];

  if (container.tagName !== "IFRAME") {
    if (container.contains(target)) {
      return true;
    }
    iframes = [...container.querySelectorAll("iframe")];
  } else {
    if (!container.contentDocument) {
      return false;
    }
    if (container.contentDocument.contains(target)) {
      return true;
    }
    iframes = [...container.contentDocument.querySelectorAll("iframe")];
  }

  if (!iframes.length) {
    return false;
  }
  return iframes.some((iframe) => {
    return _isElementInsideContainer(iframe, target);
  });
}

function _isElementInsideContainer(iframe, target) {
  if (!iframe.contentDocument) {
    return false;
  }

  if (iframe.contentDocument.contains(target)) {
    return true;
  }

  let iframes = [...container.contentDocument.querySelectorAll("iframe")];

  if (!iframes.length) {
    return false;
  }

  return iframes.some((iframe) => {
    return _isElementInsideContainer(iframe, target);
  });
}

function findFrameAbsoluteRect(element) {
  let currentWindow = window;
  let currentParentWindow;
  let positions = [];
  let rect = element
    ? element.getBoundingClientRect()
    : document.body.getBoundingClientRect();
  while (currentWindow !== window.top) {
    currentParentWindow = currentWindow.parent;
    for (let frameElement of currentParentWindow.document.getElementsByTagName(
      "iframe"
    )) {
      if (frameElement.contentWindow === currentWindow) {
        const frameRect = frameElement.getBoundingClientRect();
        positions.push({ x: frameRect.x, y: frameRect.y });
      }
    }
    currentWindow = currentParentWindow;
    break;
  }

  positions = positions.reduce(
    (accumulator, currentValue) => {
      return {
        x: accumulator.x + currentValue.x,
        y: accumulator.y + currentValue.y,
      };
    },
    { x: rect.x, y: rect.y }
  );
  return {
    x: positions.x,
    y: positions.y,
    top: rect.top,
    bottom: rect.bottom,
    left: rect.left,
    right: rect.right,
    width: rect.width,
    height: rect.height,
  };
}

/**
 * get root domain(ex:.vpon.com)
 * @param {Object} location location object
 * @returns root domain string
 */
const getRootDomain = (location = window.location) => {
  if (!isUrl(location.href)) {
    return;
  }

  const { hostname } = location;
  const hostStringArray = hostname.split(".");

  //If the hostname has at least two parts, return the last two parts
  if (hostStringArray.length >= 2) {
    return (
      hostStringArray[hostStringArray.length - 2] +
      "." +
      hostStringArray[hostStringArray.length - 1]
    );
  }

  //Otherwise, return entrire hostname
  return hostname;
};

/**
 * UID generator
 * @returns generation UID
 */
function generateUID() {
  if (crypto && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  const S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };

  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
}

/**
 * handle request ad parameters
 * @param {object} vponTag vpon tag
 * @returns request parameters
 */
const getReqAdParameters = (vponTag) => {
  let reqParameters = {};

  const adType = checkAdType(vponTag);
  if (adType == "na") {
    reqParameters.cover_min =
      vponTag.getAttribute(websdkParams.nativeCoverMin) || "";
  }
  reqParameters.format = vponTag.getAttribute(websdkParams.format);
  reqParameters.sdk = websdkParams.sdk;
  reqParameters.bid = vponTag.getAttribute(websdkParams.licensekey);
  reqParameters.adtest = vponTag.getAttribute(websdkParams.adTest) == 1 ? 1 : 0;
  reqParameters.adRequestCallBack = vponTag.getAttribute(
    websdkParams.adRequestCallBack
  );
  reqParameters.isRotate =
    vponTag.getAttribute(websdkParams.isRotate) || "true";
  reqParameters.s_h = document.documentElement.clientHeight;
  reqParameters.s_w = document.documentElement.clientWidth;

  return reqParameters;
};

/**
 * Adder
 * @param {*} initialValue adder initial value
 * @returns {number} result value.
 */
function adder(initialValue = 0) {
  let value = initialValue;

  return (num = 1) => {
    value += num;
    return value;
  };
}

let CTID = "";

function getCTID() {
  return CTID;
}

/**
 * Prepare context for ad request(cookie & localStorage)
 * vpadn-ctid: ad request url query
 * vpadn-vpid: 3rd party cookie
 */
function prepareContextForAdRequest() {
  const { getCookieByKey, setCookie, idsService } = vpadnCookieComponent;
  const cookieDomain = getTopReachableDomain();
  var CTID;

  // Ensure that the localStorage.getItem method exists.
  if (window.localStorage && typeof window.localStorage.getItem === 'function') {
    CTID =
      getCookieByKey(websdkParams.cookie.ctid) ||
      window.localStorage.getItem(websdkParams.cookie.ctid) ||
      generateUID();
  } else {
    CTID =
      getCookieByKey(websdkParams.cookie.ctid) ||
      generateUID();
  }


  if (verifyCtid(CTID)) {
    CTID = `v1_${CTID}.${new Date().getTime()}`;
  }

  if (window.localStorage) {
    window.localStorage.setItem(websdkParams.cookie.ctid, CTID);
  }

  const options = {
    path: "/",
    "max-age": 63072000, //two years
    domain: cookieDomain,
  };

  setCookie(websdkParams.cookie.ctid, CTID, options);

  let seid = getCookieByKey(websdkParams.cookie.seid);
  let key;

  if (
    !seid ||
    getTopReachableDomain(document.referrer) !== cookieDomain ||
    !new RegExp("^" + key).test(seid)
  ) {
    seid = `${key}-${Math.floor((1 * new Date()) / 100)}`;
    const options = {
      path: "/",
      "max-age": 1800, // 30 mins
      domain: cookieDomain,
    };
    setCookie(websdkParams.cookie.seid, seid, options);
  }

  if (
    getCookieByKey(websdkParams.cookie.thirdCookieEnabledFlag) !== "0" &&
    getCookieByKey(websdkParams.cookie.thirdCookieEnabledFlag) !== "1"
  ) {
    const ctidObj = parseCtidToObj(CTID);
    const { ctid } = ctidObj;
    idsService(cookieDomain, ctid);
  }
}

/**
 * Vpadn cookie component, Used for get cookie by key and set cookie
 * @param {string} key cookie name
 * @param {string} value cookie value
 * @param {object} options cookie setting options
 */
const vpadnCookieComponent = {
  idsService: (cookieDomain, ctid) => {
    const { protocol } = location;
    const beaconUrl = `${protocol}//ids-dmp.vpadn.com/set?t=${
      1 * new Date()
    }&dn=${encodeURIComponent(cookieDomain)}&ctid=${ctid}`;

    sendBeaconAjax(
      beaconUrl,
      SetHelper.setCallback,
      SetHelper.setErrorCallback
    );
  },
  getCookieByKey: (key) => {
    const isValid = cookieParamsValidator({ key });

    if (!isValid) {
      return;
    }

    const cookies = document.cookie;
    const cookiesArr = cookies.split(";").map((item) => item.trim());
    const targetCookie = cookiesArr.find((cookie) => {
      return cookie.split("=")[0] === key;
    });

    if (!targetCookie) {
      console.warn(`[Vpon-WebSDK] Can't find key => ${key}!`);
      return;
    }

    return targetCookie.split("=")[1];
  },
  setCookie: (key, value, options) => {
    const isValid = cookieParamsValidator({ key, value, options });

    if (!isValid) {
      return;
    }

    const cookieString = generateCookieString(key, value, options);
    document.cookie = cookieString;
  },
};

const generateCookieString = (key, value, options) => {
  let cookieString = `${key}=${value}`;
  Object.keys(options).forEach((key) => {
    if (options[key] !== "secure") {
      cookieString += `;${key}=${options[key]}`;
      return;
    }
    cookieString += ";secure";
  });
  return cookieString;
};

var sendBeaconAjax = function (url, cb, errorCb) {
  var xmlHttp = new XMLHttpRequest();

  xmlHttp.timeout = 10000;
  xmlHttp.withCredentials = true;

  xmlHttp.onreadystatechange = function () {
    if (
      xmlHttp.readyState === 4 &&
      xmlHttp.status === 200 &&
      cb !== undefined
    ) {
      cb(xmlHttp.responseText);
    } else if (xmlHttp.readyState === 4 && errorCb !== undefined) {
      errorCb(xmlHttp.responseText);
    }
  };
  xmlHttp.open("GET", url, true); // true for asynchronous
  xmlHttp.send();
};

var cookie = {
  write: function (name, value, days, domain, path) {
    var date = new Date();
    days = days || 730; // two years
    path = path || "/";
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
    var cookieValue = `${name}=${value}${expires}; path=${path}; SameSite=None; Secure`;
    if (domain) {
      cookieValue += "; domain=" + domain;
    }
    document.cookie = cookieValue;
  },
  read: function (name) {
    var allCookie = "" + document.cookie;
    var index = allCookie.indexOf(name);
    if (name === undefined || name === "" || index === -1) return "";
    var ind1 = allCookie.indexOf(";", index);
    if (ind1 == -1) ind1 = allCookie.length;
    return unescape(allCookie.substring(index + name.length + 1, ind1));
  },
  remove: function (name) {
    if (this.read(name)) {
      this.write(name, "", -1, "/");
    }
  },
};

var SetHelper = {
  setCallback: function (e) {
    var json = JSON.parse(e);
    const JSON_KEY = "vponId";
    const THIRD_COOKIE_ENABLED_FLAG = "vpadn-ce";
    const JSON_THIRDPARTY_KEY = "ce";
    const COOKIE_LIFE_DAY = 7;
    const COOKIE_DOMAIN = getTopReachableDomain();

    if (json !== undefined && json[JSON_KEY] !== undefined) {
      // if (json[JSON_KEY] !== '0') {
      //     cookie.write(VPID_KEY, json[JSON_KEY], COOKIE_LIFE_DAY, COOKIE_DOMAIN);
      // }

      //if 3rd cookie setting failed, set a flag in 1st party cookie
      cookie.write(
        THIRD_COOKIE_ENABLED_FLAG,
        json[JSON_THIRDPARTY_KEY],
        COOKIE_LIFE_DAY,
        COOKIE_DOMAIN
      );
    }
  },
  setErrorCallback: function (e) {},
};

/**
 * Initialize third party vender
 */
//function initialThirdPartyVendor() {
//  initialEland();
//  initialHinet();
//}

const checkInput = (vponTag) => {
  var result = {
    errMsg: "",
    adhesionPosition: false,
  };

  var licensekey = vponTag.getAttribute(systemVar.licensekey);
  if (!checkAttributeIsGiven(licensekey)) {
    result.errMsg += "input licensekey is empty. ";
  }
  var regex = /^[A-Za-z0-9]{32}$/;
  if (!regex.test(licensekey)) {
    result.errMsg += "input licensekey error length. ";
  }

  result.adType = checkAdType(vponTag);

  var adhesionPosition = vponTag.getAttribute(systemVar.adhesionPosition);
  if (adhesionPosition) {
    if (adhesionPosition === "top") {
      result.adhesionPosition = "top";
    } else if (adhesionPosition === "bottom") {
      result.adhesionPosition = "bottom";
    } else {
      result.adhesionPosition = "unknown";
    }
  } else {
    result.adhesionPosition = false;
  }

  return result;
};

const initialIntIframeHtmlTag = (vponTag, guid) => {
  var iframeId = guid + "_int_1";
  var iframe = document.createElement("IFRAME");
  iframe.style.width = "100%";
  iframe.style.height = "100%";
  iframe.setAttribute("id", iframeId);
  iframe.setAttribute("scrolling", "no");
  iframe.frameBorder = 0;

  var container = initialCloseButtonContainer(vponTag, iframeId, "int");
  var closeBtn = initialIntCloseButton(vponTag, iframeId);

  container.appendChild(closeBtn);
  container.appendChild(iframe);
  vponTag.appendChild(container);
};

/**
 * Todo: When ad response component refactoring in the
 * future, Move this function to ad response phase.
 * Create intistitial ad iframe, Contains the following two results.
 * 0: Some problem happen
 * 1: Success
 * @param {element} vponTag vpon tag node
 * @returns {number} result
 */
const vpon_ad_create_int_iframe = (vponTag) => {
  // check if vpontag already generate ad(iframes)
  if (vponTag.querySelectorAll("iframe").length > 0) {
    console.info(
      "ERROR: ad(iframes) had exists inside vpontag, will not generate ad(iframes) again."
    );
    return 0;
  }

  // check vpon tag attribute
  var checkInputResult = checkInput(vponTag);
  if (checkInputResult.errMsg) {
    var debugMode = vponTag.getAttribute(systemVar.debug);
    if (debugMode) {
      console.info(
        "ERROR: vpon tag fill attribute error, message => " +
          checkInputResult.errMsg
      );
    }
    return 0;
  }

  if (vponTag.getAttribute("status") == null) {
    vponTag.setAttribute("status", "1");
  } else {
    return 0;
  }

  var licenseKey = vponTag.getAttribute(systemVar.licensekey);
  var guid = licenseKey + "_" + generateUID();

  // initial iframe html tag
  initialIntIframeHtmlTag(vponTag, guid);

  return 1;
};

/**
 * Handle ad request url with ad request parameters.
 * @param {object} reqAdParameters ad request parameters
 * @returns {object} ad request url object
 */
function handleAdReqUrl(reqAdParameters) {
  const { apiConfig } = websdkParams;
  const adReqUrl = new URL(
    `${apiConfig.protocol}${apiConfig.hostname}${apiConfig.path.adRequest}`
  );

  Object.keys(reqAdParameters).forEach((key) => {
    adReqUrl.searchParams.append(key, encodeURIComponent(reqAdParameters[key]));
  });

  return adReqUrl;
}

// ------------- function ------------

module.exports = {
  endsWith,
  s4,
  genGuid,
  getCookie,
  uaMatch,
  isSDKiOS,
  isIPhone,
  isSDKiOSNotIPhone,
  parseParamsFromUrl,
  regexp_replace,
  parseCtidToObj,
//  initialHinet,
//  initialEland,
  fade,
  fading,
  fadeLock,
  fadeForFlrec,
  getParams,
  calculateViewRate,
  generateUID,
  getRootDomain,
  getReqAdParameters,
  adder,
  prepareContextForAdRequest,
  vpadnCookieComponent,
//  initialThirdPartyVendor,
  vpon_ad_create_int_iframe,
  handleAdReqUrl,
  getCTID
};



// WEBPACK FOOTER //
// ./src/vpadn-sdk-features.partial.js